import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <div>
          
        </div>
        <div className="ml-auto">
          <span>
            Powered by <a href="http://psctelecom.com.vn/" rel="noopener noreferrer" target="_blank">PSC</a>. © 2018 PSC All rights reserved
          </span>
        </div>
      </footer>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/layout/footer.jsx